import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        // Dashboard
        {
          name: 'Dashboard',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        // Calendar
         {
          name: 'Calendar',
          path: 'calendars/Calendar',
          component: () => import('@/views/calendars/Calendar'),
        },
       //User Dara
        {
          name: 'Documents',
          path: 'data/documents',
          component: () => import('@/views/data/Documents'),
        },
        // Locations
        {
          name: 'Locations',
          path: 'locations/list',
          component: () => import('@/views/dashboard/locations/ListLocations'),
        },
        {
          name: 'Users',
          path: 'users/list',
          component: () => import('@/views/dashboard/users/ListUsers'),
        },
        {
          name: 'Add Locations',
          path: 'locations/add',
          component: () => import('@/views/dashboard/locations/AddLocations'),
        },
        // Maps
        {
          name: 'Calendar',
          path: 'calendars/calendar',
          component: () => import('@/views/calendars/Calendar'),
        },
      ],
    },
  ],
})
